import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ServerTypes } from 'src/app/models/servers';

@Injectable()
export class EsbService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  private get url(): string {
    return this.apiService.getCurentServer(ServerTypes.boapi);
  }
 
    public getLatesMessage(): Observable<any> {
        return this.http.get<any>(this.url +'v1/esb/messages/workorder/history');
    }
    public getMessage(messageId: string): Observable<any> {
        return this.http.get<any>(this.url +'v1/esb/messages/' + messageId);
    }

    public resetRetriesEvent(messageId: string, eventId: string): Observable<any> {
        return this.http.post(this.url + 'v1/esb/messages/' + messageId + '/events/' + eventId + '/resetretry', null);
    }

    public dispatchEvent(messageId: string, eventId: string): Observable<any> {
        return this.http.post(this.url + 'v1/esb/messages/' + messageId + '/events/' + eventId + '/retrydispatch', null);
    }

    public dispatchCommand(messageId: string): Observable<any> {
        return this.http.post(this.url + 'v1/esb/messages/' + messageId + '/retrydispatch', null);
    }

    public postMessage(message: any): Observable<any> {
        return this.http.post(this.url + 'v1/commands', message);
    }

    public deleteMessage(messageId: string): Observable<any> {
        return this.http.delete<any>(this.url +'v1/esb/messages/' + messageId);
    }
}
